import BmWmsCodeIndex from "@/components/billing_cml/bm_code/BmWmsCodeIndex.vue";

let routesCmlBmWmsCode= [
    {
        path: '',
        meta: {
          title: "CML List WMS Code",
        },
        name: "BmWmsCodeIndex",
        component: BmWmsCodeIndex
    },
    
]

export default routesCmlBmWmsCode
  